<div class="d-flex align-items-center justify-content-center flex-column mt-3">
    <button #homeBtn class="glass zoom-on-hover" (click)="toHomePage()">Home</button>
    <button #aboutBtn class="glass zoom-on-hover" (click)="toAboutPage()">About</button>
    <button #skillsBtn class="glass zoom-on-hover" (click)="toSkillsPage()">Skills</button>
    <button #experienceBtn class="glass zoom-on-hover" (click)="toExperiencePage()">Experience</button>
    <button #contatcsBtn class="glass zoom-on-hover" (click)="toContactsPage()">Contacts</button>
</div>
